import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DownloadInvoices } from '../../../../models/invoices-reports.model';

@Component({
  selector: 'app-swk-government',
  templateUrl: './swk-government.component.html',
  styleUrls: ['./swk-government.component.css']
})
export class InvoicesSwkGovernmentComponent implements OnInit, OnDestroy {
  swkinvoicesreportform: FormGroup;
  allSub: Subscription[] = [];
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  accOffCodes = [];
  exportFileTypes = [];
  downloadInvoices: DownloadInvoices = new DownloadInvoices();
  fileType = [
    { value: '.pdf', viewValue: 'PDF File' },
    { value: '.xls', viewValue: 'Excel File' }
  ];

  constructor(private userService: UserService,
    private reportService: ReportService,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.swkinvoicesreportform = new FormGroup({
      invDate: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      airAsiaRef: new FormControl({ value: '', disabled: false }),
      bookingDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      bookingDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      exportFileType: new FormControl({ value: this.fileType[0].value, disabled: false }),
      invoiceNo: new FormControl({ value: '', disabled: false })
    });
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    this.downloadInvoices.AirAsiaRef = this.swkinvoicesreportform.get('airAsiaRef')!.value;
    this.downloadInvoices.AccountOfficeCode = '';
    this.downloadInvoices.BookingDateFrom = this.swkinvoicesreportform.get('bookingDateFrom')!.value;
    this.downloadInvoices.BookingDateTo = this.swkinvoicesreportform.get('bookingDateTo')!.value;
    this.downloadInvoices.InvoiceDate = this.swkinvoicesreportform.get('invDate')!.value;
    this.downloadInvoices.ExportFileType = this.swkinvoicesreportform.get('exportFileType')!.value;
    this.downloadInvoices.InvoiceNumber = this.swkinvoicesreportform.get('invoiceNo').value;  

    let update_sub = this.reportService.downloadSwkInvoices(this.downloadInvoices)
      .subscribe(
        (value) => {
          if (value.status === 204) {

          } else if (value.status === 200) {
            if (this.downloadInvoices.ExportFileType === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'SWK Invoice.xls');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            } else if (this.downloadInvoices.ExportFileType === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'SWK Invoice.pdf');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            }
          } else {
            this.isSubmit = false;
            this.openSnackBar('Error downloading invoice.', '');
          }
        },
        (error) => {
          this.isSubmit = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(update_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
